import React, { useEffect, useState } from "react";
import staticConfig from "../config";

interface MyContext {
  [name: string]: any;
}

export const ConfigContext = React.createContext<[MyContext, boolean | null]>([
  {},
  null
]);

export const ConfigContextProvider = props => {
  const [config, setConfig] = useState({});
  const [isConfigLoading, setIsConfigLoading] = useState(true);

  useEffect(() => {
    const getConfig = async () => {
      const response = await fetch("/settings.json");
      const vars = await response.json();
      const oidc = { ...vars.oidc, ...staticConfig.oidc };
      const app = { ...vars.app, ...staticConfig.app };
      const  Modifiedconfig = { ...staticConfig, oidc, app };
      Modifiedconfig.rbacRoles.push(...vars.rbacRoles);
      if (window.location.host === (Modifiedconfig && Modifiedconfig.app && Modifiedconfig.app.oldUri)) {
        window.location.replace(Modifiedconfig.app.newUri);
        return;
      }
      setConfig(Modifiedconfig);
      setIsConfigLoading(false);
    };
    getConfig();
  }, [setConfig, setIsConfigLoading]);

  return (
    <ConfigContext.Provider value={[config, isConfigLoading]}>
      {props.children}
    </ConfigContext.Provider>
  );
};
